module.exports = __webpack_public_path__ + "img/96.be425d69.png";